import { derived, writable } from "svelte/store";

export const windowState = writable({
  width: window.innerWidth,
  height: window.innerHeight,
});

export const windowIsMobile = derived(
  windowState,
  (state) => state.width <= 720
);

window.addEventListener(
  "resize",
  () => {
    windowState.update((d) => {
      return {
        ...d,
        width: window.innerWidth,
        height: window.innerHeight,
      };
    });
  },
  { passive: true }
);
